// src/components/features/departures/SearchPage/DeparturesSearchPage.tsx
import { StateMessage } from '../../../base/StateMessage/StateMessage';
import { SearchPage } from '../../../widget/Pages/Pages';
import { StopSearchForm } from '../StopSearchForm/StopSearchForm';
import { Heading } from '../../../base/Heading/Heading';
import { Link } from '../../../base/Link/Link';
import type { PlaceOption } from '../../../../data/places';
// styles
import styles from './DeparturesSearchPage.module.css';

interface DeparturesSearchPageProps {
  locationQuery: string;
  setLocationQuery: (value: string) => void;
  locationOptions: PlaceOption[];
  onSubmit: (event?: SubmitEvent, selection?: PlaceOption) => void;
  onUseCurrentLocation: () => void | Promise<void>;
  searchLocationsError: Error | null;
  submitError: string | null;
}

/**
 * Departures search page with location lookup and submission feedback.
 */
export function DeparturesSearchPage({
  locationQuery,
  setLocationQuery,
  locationOptions,
  onSubmit,
  onUseCurrentLocation,
  searchLocationsError,
  submitError,
}: DeparturesSearchPageProps) {
  return (
    <SearchPage>
      <Heading as="h2" variant="lg">
        Departures
      </Heading>

      <StopSearchForm
        value={locationQuery}
        options={locationOptions}
        onValueChange={setLocationQuery}
        onSubmit={onSubmit}
        onUseCurrentLocation={onUseCurrentLocation}
        autoSubmitOnSelect
        showSubmitButton={false}
      />

      {false && (
        <div className={styles.linkWrapper}>
          <Link>Or, find your stop on the map</Link>
        </div>
      )}

      {searchLocationsError && (
        <StateMessage
          state="error"
          title="Location lookup failed"
          message={searchLocationsError.message}
        />
      )}

      {submitError && (
        <StateMessage
          state="error"
          title="Missing location"
          message={submitError}
        />
      )}
    </SearchPage>
  );
}
